/**
 * Base error class for template storage operations
 */
export class TemplateStorageError extends Error {
    constructor(message, cause) {
        super(message);
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: cause
        });
        this.name = 'TemplateStorageError';
        // Maintain proper stack trace for where our error was thrown
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TemplateStorageError);
        }
    }
}
/**
 * Error thrown when template validation fails
 */
export class TemplateValidationError extends TemplateStorageError {
    constructor(message, validationDetails) {
        super(message);
        Object.defineProperty(this, "validationDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: validationDetails
        });
        this.name = 'TemplateValidationError';
        // Maintain proper stack trace
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TemplateValidationError);
        }
    }
}
/**
 * Error thrown when template access is denied
 */
export class TemplateAccessError extends TemplateStorageError {
    constructor(message, templateId) {
        super(message);
        Object.defineProperty(this, "templateId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: templateId
        });
        this.name = 'TemplateAccessError';
        // Maintain proper stack trace
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TemplateAccessError);
        }
    }
}
/**
 * Error thrown when a template is not found
 */
export class TemplateNotFoundError extends TemplateStorageError {
    constructor(message, templateId, plannerId) {
        super(message);
        Object.defineProperty(this, "templateId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: templateId
        });
        Object.defineProperty(this, "plannerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: plannerId
        });
        this.name = 'TemplateNotFoundError';
        // Maintain proper stack trace
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TemplateNotFoundError);
        }
    }
}
/**
 * Error thrown when there's an issue with the storage service
 */
export class StorageServiceError extends TemplateStorageError {
    constructor(message, bucket, path, cause) {
        super(message, cause);
        Object.defineProperty(this, "bucket", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: bucket
        });
        Object.defineProperty(this, "path", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: path
        });
        this.name = 'StorageServiceError';
        // Maintain proper stack trace
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, StorageServiceError);
        }
    }
}
